export default __webpack_public_path__ + "static/media/Accreditation-1.43876be1.png";